<template>
  <div>
    <el-card class="search-form-con">
      <div class="trck-name-input-wrapper">
        <el-input
          :placeholder="$t('track.trackNamePlaceholder')"
          v-model="trackName"
          clearable
          :disabled="searching"
          class="track-name-input"
          @keyup.enter.native="handleSearch"
        >
          <el-select
            v-model="trackNameSearchType"
            slot="prepend"
            class="input-with-select"
          >
            <el-option :label="$t('track.precise')" :value="1"></el-option>
            <el-option :label="$t('track.fuzzy')" :value="2"></el-option>
          </el-select>
        </el-input>
        <el-button type="primary" @click="handleSearch" :loading="searching">查 询</el-button>
        <el-button @click="handleReset" :disabled="searching">清 空</el-button>
      </div>

      <ul class="tabs">
        <li @click="trackStatus = 'stored'" :class="trackStatus==='stored'?'active tab':'tab'">已入库歌曲</li>
        <li @click="trackStatus = 'checking'" :class="trackStatus==='checking'?'active tab':'tab'">审核中歌曲</li>
      </ul>
    </el-card>

    <div class="search-form-wrapper">
      <Stored ref="storedRef" :disabled="searching" @search="handleSearch" v-show="trackStatus==='stored'"></Stored>
      <Checking ref="checkingRef" :disabled="searching" @search="handleSearch" v-show="trackStatus==='checking'"></Checking>
    </div>
  </div>
</template>

<script>
import Checking from './Checking.vue'
import Stored from './Stored.vue'

export default {
  name: 'TrackSearchForm',
  components: {
    Checking,
    Stored
  },

  props: {
    searching: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      trackNameSearchType: 1,
      trackStatus: 'stored',
      trackName: '',
    }
  },
  computed: {
    subFormRef() {
      return this.trackStatus === 'stored' ? 'storedRef' : 'checkingRef'
    }
  },
  watch: {
    trackStatus() {
      this.handleReset()
      this.$refs[this.subFormRef].showCollapse = false
      this.$emit('trackStatusChange', this.trackStatus)
    }
  },

  mounted() {
    // 设置搜索条件
    const { tab, ...restQuery } = this.$route.query
    const isStored = tab === 'stored'
    if (!isStored) {
      this.trackStatus = 'checking'
      this.$emit('trackStatusChange', this.trackStatus)
    }

    if (Object.keys(restQuery).length) {
      this.$refs[isStored ? 'storedRef' : 'checkingRef'].initData(restQuery)
      this.handleSearch()
    }
  },

  methods: {
    handleSearch() {
      this.$emit('handleSearch')
    },
    handleReset() {
      this.trackName = ''
      this.$refs[this.subFormRef].handleReset()
    },
    getSearchData() {
      return {
        [`trackName${this.trackNameSearchType === 2 ? '__icontains' : ''}`]: this.trackName,
        ...this.$refs[this.subFormRef].formatForm
      }
    }
  },
}
</script>

<style lang="scss" scoped>

.search-form-con{
  padding-bottom: 0px;

  ::v-deep {
    .el-card__body {
      padding-bottom: 0px;
    }
  }

  .tabs{
    .tab {
      display: inline-block;
      font-size: 14px;
      padding: 6px 10px;
      margin: 0 6px;
      cursor: pointer;
      border-bottom: 2px solid transparent;
      transition: all 0.25s;

      &.active {
        color: #1890ff;
        border-bottom: 2px solid currentColor;
      }
    }
  }
}

.trck-name-input-wrapper{
  text-align: center;
  margin-bottom: 26px;
  margin-top: 10px;

  .track-name-input{
    width: 440px;
    margin-right: 20px;
  }
}

.search-form-wrapper{
  margin-top: 20px;
  background: #fff;
  padding: 20px 16px 10px 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.input-with-select {
  width: 100px;
}
</style>
